import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Restores scroll to the top on every route change. Has to handle three
// distinct scroll containers because Layout switches between page-flow
// scrolling and an internal scroller depending on whether the golfer
// sidebar is visible:
//
//   1. `window` — default page-flow scroll (most routes; no sidebar)
//   2. `<main>` — Layout flips this to `overflow-auto` while the golfer
//      sidebar is mounted, so window.scrollY stays at 0 but the visible
//      scroll position belongs to <main>
//   3. `[data-scroll-container]` — opt-in for any page that mounts its
//      own internal scroller (modals, dashboards, equipment lists). The
//      page just adds `data-scroll-container` to the scrolling element.
//
// We reset all three on every navigation; resetting a container that
// wasn't scrolled is a no-op. Cheaper than auditing which container is
// "live" for the route we're entering.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    const mainEl = document.querySelector('main');
    if (mainEl) mainEl.scrollTop = 0;

    document.querySelectorAll<HTMLElement>('[data-scroll-container]').forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}
